export default __webpack_public_path__ + "static/media/point-circle.90b1c5d2.svg";